var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"selector-wrapper",attrs:{"aria-label":_vm.label}},[_c('div',{staticClass:"selector-wrapper--icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"selector-wrapper--content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }